
import axios from 'axios';
import Cookies from 'js-cookie';
import { store } from '../../context/Store'
import { CONFIG } from '../../config';
const apiUrl = CONFIG.REACT_APP_API_BASE_URL;
const api = axios.create({
  baseURL: apiUrl,
  timeout: 20000,
  withCredentials: true
});


api.interceptors.request.use(
  (config) => {
    const token =Cookies.get('Token'); 
   if (token) {
     config.headers.Authorization = `Bearer ${token}`;
    }
    return config;
  },
  (error) => {
    return window.location.href = '/Pay';
  }
 );


api.interceptors.response.use(
  (response) => response,
  async (error) => {
    const originalRequest = error.config;
     const state = store.getState();
    const CredenceAccountNumber =
      state.Authentication?.CredenceAccountNumber;
    if (error.response && error.response.status === 401 && !originalRequest._retry) {
      originalRequest._retry = true;
      try {
        const refreshToken = Cookies.get('RefreshToken');
        if (!refreshToken) return window.location.href = '/Pay';
//       const response = await api.post(
//   `${apiUrl}/JWTToken/Refresh?refreshtoken=${refreshToken}&EmailID=${CredenceAccountNumber}`
// );
//         const newAccessToken = response.data;
//         Cookies.set('Token',newAccessToken);;
//         originalRequest.headers['Authorization'] = `Bearer ${newAccessToken}`;
//         return api(originalRequest);
      } catch (err) {
        Cookies.remove('Token');
        Cookies.remove('RefreshToken');
       // window.location.href = '/login'; // Redirect to login page
        return Promise.reject(err);
      }
    }
       return Promise.reject(error);
  }
);

export default api;
